/**
 * Опрос фонового обновления позиций судов, запущенного кликом «Загрузить/Обновить».
 *
 * Кнопка отвечает за океанографию и не должна ждать суда: обновление позиций идёт
 * рядом и обычно заканчивается позже. Поэтому статус опрашивается отдельно, а по
 * готовности слой флота перезапрашивается РОВНО ОДИН РАЗ.
 *
 * `prepare` возвращает `fleet_job_id = null`, когда обновлять нечего — все квадраты
 * района опрошены меньше трёх часов назад. Тогда опроса нет вовсе.
 *
 * Опрос обязан заканчиваться при любом исходе: по готовности, по ошибке и по
 * таймауту. Процесс бэкенда мог перезапуститься и потерять задачу — бесконечный
 * опрос в этом случае жёг бы запросы до закрытия вкладки.
 */

/** Период опроса статуса. */
export const FLEET_POLL_MS = 5000

/** Через сколько сдаёмся: обновление 40 квадратов укладывается в минуту. */
export const FLEET_POLL_TIMEOUT_MS = 180_000

export interface FleetRefreshStatus {
  done: boolean
  error: string | null
  updated: number
}

interface PollDeps {
  fetchStatus: (jobId: string) => Promise<FleetRefreshStatus>
  onDone: (status: FleetRefreshStatus) => void
  sleep?: (ms: number) => Promise<void>
}

const wait = (ms: number) => new Promise<void>(r => setTimeout(r, ms))

export async function pollFleetRefresh(
  jobId: string | null | undefined,
  { fetchStatus, onDone, sleep = wait }: PollDeps,
): Promise<void> {
  if (!jobId) return

  const attempts = Math.ceil(FLEET_POLL_TIMEOUT_MS / FLEET_POLL_MS)
  for (let i = 0; i < attempts; i++) {
    let status: FleetRefreshStatus
    try {
      status = await fetchStatus(jobId)
    } catch {
      // Обновление судов — побочная работа: её сетевой сбой не должен всплывать
      // на карте. Молча прекращаем опрос, точки приедут при следующем клике.
      return
    }
    if (status.done) {
      onDone(status)
      return
    }
    await sleep(FLEET_POLL_MS)
  }
}
